import { Activity } from 'src/models/activity';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { IdoActivityHistoryListCallbackStoreContract } from '../interfaces';

export class GetTheIdoActivityModuleIdoActivitiesForTheIdoCallBack extends Callback<Activity[]> {
	public constructor(
		private readonly store: IdoActivityHistoryListCallbackStoreContract,
		private readonly uniqueListIdentifier: string,
		private readonly aggregateId: string,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
		this.store.rollbackPaginationPageAction({
			aggregateId: this.aggregateId,
			page: this.page,
			queryIdentifier: this.queryIdentifier,
			uniqueListIdentifier: this.uniqueListIdentifier,
		});
	};

	finalizeCallbackFunction(): void {
		this.releaseFetchState();
		this.store.settleKeyFetching({
			aggregateId: this.aggregateId,
			queryIdentifier: this.queryIdentifier,
			uniqueListIdentifier: this.uniqueListIdentifier,
		});
	}

	successCallbackFunction = (
		successResponse: Activity[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (
			!this.store.isLatestQueryIdentifier({
				aggregateId: this.aggregateId,
				queryIdentifier: this.queryIdentifier,
				uniqueListIdentifier: this.uniqueListIdentifier,
			})
		) {
			return;
		}

		this.store.setIdoActivityHistoryList({
			aggregateId: this.aggregateId,
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
			uniqueListIdentifier: this.uniqueListIdentifier,
		});
	};
}
